module.exports = __webpack_public_path__ + "assets/stickeryo_logo@3x-035bfb73ced8ec30a640fbba4af12fc8.png";